import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { useFeatureFlagStore } from 'apps/feature-flags/src/store';
import { useFeatureFlagsApi } from 'apps/feature-flags/src/api/feature-flags';
import { ListPageTrackingEvent, trackFeatureFlagListPageAction, TrackingEventSource } from 'apps/feature-flags/src/tracking';
import { FeatureFlagPageProvider } from '../context';
import { FeatureFlagListHeader } from './header';
import { FeatureFlagListMain } from './main';
import styles from './index.module.styl';
interface FeatureFlagListViewProps {
  projectId: number;
  userId: number;
  workspaceId: number;
}
export const FeatureFlagListView: React.FC<FeatureFlagListViewProps> = _ref => {
  let {
    projectId,
    userId,
    workspaceId
  } = _ref;
  const setFeatureFlagList = useFeatureFlagStore(state => state.setFeatureFlagList);
  const {
    listFeatureFlags
  } = useFeatureFlagsApi({
    projectId
  });
  const {
    isLoading,
    isError,
    error,
    isSuccess,
    data
  } = useQuery({
    queryKey: ["featureFlags", projectId],
    queryFn: listFeatureFlags
  });
  React.useEffect(() => {
    if (isSuccess && data) {
      setFeatureFlagList(data);
    }
    trackFeatureFlagListPageAction({
      event: ListPageTrackingEvent.ListLoaded,
      source: TrackingEventSource.ListPageMain,
      props: {
        isSuccess,
        numberOfFeatureFlags: (data === null || data === void 0 ? void 0 : data.length) || 0
      }
    });
  }, [isSuccess, data, setFeatureFlagList]);
  React.useEffect(() => {
    if (isError) {
      addToast({
        message: error.message,
        type: ToastType.ERROR
      });
    }
  }, [isError, error]);
  React.useEffect(() => {
    trackFeatureFlagListPageAction({
      event: ListPageTrackingEvent.PageLoaded
    });
  }, []);
  if (isLoading) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <FeatureFlagPageProvider projectId={projectId} workspaceId={workspaceId} userId={userId} data-sentry-element="FeatureFlagPageProvider" data-sentry-component="FeatureFlagListView" data-sentry-source-file="index.tsx">
      <div className={styles.wrapper}>
        <FeatureFlagListHeader data-sentry-element="FeatureFlagListHeader" data-sentry-source-file="index.tsx" />
        <FeatureFlagListMain projectId={projectId} workspaceId={workspaceId} data-sentry-element="FeatureFlagListMain" data-sentry-source-file="index.tsx" />
      </div>
    </FeatureFlagPageProvider>;
};